import CryptoJS from 'crypto-js'

// Encrypt
export const setEncryptRole = async (userRole: string) => {
  const setEncryptRole = CryptoJS.AES.encrypt(userRole, 'encRole').toString()

  localStorage.setItem('role', setEncryptRole)
}

// Decrypt
export const getDecryptRole = () => {
  const getDecryptRole = localStorage.getItem('role')

  if (!getDecryptRole) {
    return null
  }

  const decryptRole = CryptoJS.AES.decrypt(getDecryptRole, 'encRole')
  const originalRole = decryptRole.toString(CryptoJS.enc.Utf8)

  return originalRole
}
